import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Stkmq { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '商品代號 (MQ001) 不可空白'}) 
    @MaxLength(8,{message: '商品代號 (MQ001) 資料太長'})
    MQ001: string = '';            // 商品代號 8 只有最新.無歷史

    @IsNotEmpty({message: '帳號 (MQ002) 不可空白'}) 
    @MaxLength(20,{message: '帳號 (MQ002) 資料太長'})
    MQ002: string = '';            // 帳號 20 ACCOUNT_NO

    @IsNotEmpty({message: '登入代號 (MQ003) 不可空白'}) 
    @MaxLength(10,{message: '登入代號 (MQ003) 資料太長'})
    MQ003: string = '';            // 登入代號 10 LOGIN_ID


    MQ004: Date | undefined;            // datetime 0 更新時間

    @MaxLength(1,{message: '庫存種類 (MQ005) 資料太長'})
    MQ005: string = 'T';            // 庫存種類 1 [DEF:"T"] {{T:集保 C:融資 L:融券}}

    @IsNumber() 
    MQ006: number = 0;            // 資額度(原始) 11 

    @IsNumber() 
    MQ007: number = 0;            // 資額度(可用) 11 

    @IsNumber() 
    MQ008: number = 0;            // 券額度(原始) 11 

    @IsNumber() 
    MQ009: number = 0;            // 券額度(可用) 11 

    @IsNumber() 
    MQ010: number = 0;            // 股數:昨日庫存 8 

    @IsNumber() 
    MQ011: number = 0;            // 今日委買 11.2 

    @IsNumber() 
    MQ012: number = 0;            // 今日委賣 11.2 

    @IsNumber() 
    MQ013: number = 0;            // 今日買進成交 11.2 

    @IsNumber() 
    MQ014: number = 0;            // 今日賣出成交 11.2 

    @IsNumber() 
    MQ015: number = 0;            // 今日可回補可賣出 11 今日資券可回補/集保庫存可賣出,

    @IsNumber() 
    MQ016: number = 0;            // 可資沖股數 11 

    @IsNumber() 
    MQ017: number = 0;            // 可券沖股數 11 

    @IsNumber() 
    MQ018: number = 0;            // 即時庫存 11 

    @MaxLength(1,{message: 'X(此欄請忽略) (MQ019) 資料太長'})
    MQ019: string = '';            // X(此欄請忽略) 1 

    @IsNumber() 
    MQ020: number = 0;            // 即時個股維持率 8.4 


}
